import React, {useEffect, useState} from "react";
import {getJSON} from "../api.js";
import {LoadingState, ErrorState} from "./LoadingState.jsx";
import {PortfolioCards} from "./PortfolioCards.jsx";
import {WarningsNotice} from "./WarningsNotice.jsx";

export function PortfoliosPage({analysisWindow, refreshKey, onRefreshed}) {
    const [state, setState] = useState({loading: true, error: null, data: null});
    useEffect(() => {
        let cancelled = false;
        setState({loading: true, error: null, data: null});
        getJSON(`/api/portfolios?window=${encodeURIComponent(analysisWindow)}`)
            .then((data) => {
                if (!cancelled) {
                    setState({loading: false, error: null, data});
                    onRefreshed(`Snapshot refreshed · ${data.window.toUpperCase()} analysis`);
                }
            })
            .catch((error) => {
                if (!cancelled) setState({loading: false, error, data: null});
            });
        return () => {
            cancelled = true;
        };
    }, [analysisWindow, refreshKey, onRefreshed]);
    if (state.loading) return <LoadingState/>;
    if (state.error) return <ErrorState error={state.error}/>;
    return (
        <section className="section panel">
            <div className="panel-head section-head">
                <div><h2>Portfolios</h2></div>
                <div className="subtle">
                    {state.data.portfolios.length}
                    {" "}
                    portfolios
                </div>
            </div>
            <WarningsNotice warnings={state.data.warnings}/>
            <PortfolioCards portfolios={state.data.portfolios}/>
        </section>
    );
}
